module.exports = __webpack_public_path__ + "static/media/alex_shyba.655bf264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/collections/altolans/images/alex_shyba.jpg
// module id = 994
// module chunks = 0